import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=63c4805e"
import script from "./CarForm.vue?vue&type=script&lang=js"
export * from "./CarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c4805e')) {
      api.createRecord('63c4805e', component.options)
    } else {
      api.reload('63c4805e', component.options)
    }
    module.hot.accept("./CarForm.vue?vue&type=template&id=63c4805e", function () {
      api.rerender('63c4805e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/treetable/CarForm.vue"
export default component.exports